angular.module('wbServices').factory('finance', () => {
  const interestFactor = (rate, periods) => Math.pow(1 + rate, periods);

  this.realRateOfReturn = (nominalRate, inflationRate) => ((1 + nominalRate) / (1 + inflationRate)) - 1;

  this.getPeriodicRate = (rate, frequency) => interestFactor((rate), (1 / frequency)) - 1;

  this.futureValue = (presentValue, rate, periods) => presentValue * interestFactor(rate, periods);

  this.presentValue = (futureValue, rate, periods) => futureValue / interestFactor(rate, periods);

  this.futureValueByContributionFrequency = (contribution, frequency, rate, years, presentValue) => {
    let runningTotal = presentValue;
    const periodicRate = this.getPeriodicRate(rate, frequency);

    for (let i = 0; i < frequency * years; i++) {
      runningTotal += (runningTotal * periodicRate) + contribution;
    }
    return runningTotal;
  };

  this.futureValueOfAnnuity = (payment, rate, periods, presentValue = 0) => {
    if (rate === 0) {
      return presentValue + (payment * periods);
    }
    return this.futureValue(presentValue, rate, periods) + ((payment * (interestFactor(rate, periods) - 1)) / rate);
  };

  this.presentValueOfAnnuity = (payment, rate, periods, futureValue = 0) => {
    if (rate === 0) {
      return futureValue + (payment * periods);
    }
    return ((payment * (1 - interestFactor(rate, -periods))) / rate) +
      this.presentValue(futureValue, rate, periods);
  };

  this.annuityPaymentFromPresentValue = (presentValue, rate, periods, futureValue = 0) => {
    if (rate === 0) {
      return (presentValue - futureValue) / periods;
    }
    return (rate * (presentValue - this.presentValue(futureValue, rate, periods))) /
      (1 - interestFactor(rate, -periods));
  };

  this.annuityPaymentFromFutureValue = (futureValue, rate, periods, presentValue = 0) => {
    if (rate === 0) {
      return (futureValue - presentValue) / periods;
    }
    return ((futureValue - this.futureValue(presentValue, rate, periods)) * rate) /
      (interestFactor(rate, periods) - 1);
  };

  this.periods = (rate, payment, presentValue = 0) => {
    if (rate === 0) {
      return presentValue / payment;
    }
    let result = 1 - ((presentValue * rate) / payment);
    result = Math.log(1 / result);
    return result / Math.log(1 + rate);
  };

  this.cdnMortgageRate = (rate) => {
    const result = Math.pow(interestFactor(rate / 2, 2), 1 / 12) - 1;
    return 12 * result;
  };

  return this;
});
